import { type InputHTMLAttributes, forwardRef } from 'react'

import { cn } from '@/lib/utils'

/**
 * Plain `<input>` styled to match the rest of the admin chrome.
 *
 * Sized for desktop (40px tall, 14px text) — the bigger driver
 * PWA inputs don't make sense here. Comes without a label /
 * helper-text wrapper so callers can use it inside `<Label>` +
 * `<p>` combos with full control of the layout (form rows
 * sometimes want labels on the left, sometimes above).
 */
export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid = false, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        'h-10 w-full rounded-md border bg-surface px-3 text-sm text-text',
        'placeholder:text-text-muted',
        'transition-colors duration-100',
        'focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand focus:ring-offset-0',
        'disabled:cursor-not-allowed disabled:opacity-60',
        invalid ? 'border-danger focus:border-danger focus:ring-danger' : 'border-surface-border',
        className,
      )}
      {...props}
    />
  )
})
